import { render } from "./CompanyInviteExpertRedirectView.vue?vue&type=template&id=6278fa70&ts=true"
import script from "./CompanyInviteExpertRedirectView.vue?vue&type=script&lang=ts"
export * from "./CompanyInviteExpertRedirectView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__